<template>
  <div class="wrapper">
    <side-bar :type="'sidebar'" :sidebar-links="$sidebar.sidebarLinks">
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar"></dashboard-content>
      <admin-footer></admin-footer>
      <div id="backtoTop" @click="scrollToTop()">
        <span class="fa fa-chevron-up"></span>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import TopNavbar from './TopNavbar.vue'
  import AdminFooter from './Footer.vue'
  import SideBar from '@/components/ui/SideBar.vue'
  import DashboardContent from './Content.vue'
  export default {
    name: 'Layout',
    components: {
      TopNavbar,
      AdminFooter,
      DashboardContent,
      SideBar
    },
    computed: {
      ...mapGetters([
        '$sidebar'
      ])
    },
    data () {
      return {
        scroll: 0
      }
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$store.commit('displaySidebar', false)
        }
      },
      scrollToTop () {
        this.scroll = setInterval(this.scrollStep, 16.66)
      },
      scrollStep () {
        if (window.pageYOffset === 0) {
          clearInterval(this.scroll)
        }
        window.scroll(0, window.pageYOffset - 1000)
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/admin/Layout.vue